const SatelliteViewType = {
	OFF: "off",
	REGULAR: "regular",
	SATURATED: "saturated",
	GREYSCALE: "greyscale",
	SEPIA: "sepia"
};
export default SatelliteViewType;
